<template>
  <div class="explore">
    <div class="explore-title">
      <CustomBreadcrumb/>
    </div>
    <div class="explore-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="AI Recommendations" name="aiRecommendations"><AiRecommendations v-if="activeName === 'aiRecommendations'"/></el-tab-pane>
        <el-tab-pane label="Explore" name="explore"><Explore :user-id="userId" :store-id="storeId" :store-name="storeName" :store-address="storeAddress" :is-show-report="isShowReport" v-if="activeName === 'explore'"/></el-tab-pane>
        <el-tab-pane label="Widget" name="widget"><Widget v-if="activeName === 'widget'"/></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CustomBreadcrumb from '../components/custom-breadcrumb'
import Explore from './explore.vue'
import AiRecommendations from './ai-recommendations.vue'
import Widget from './widget.vue'

export default {
  components: {
    CustomBreadcrumb,
    AiRecommendations,
    Explore,
    Widget
  },
  data() {
    return {
      activeName: 'aiRecommendations',
      isShowReport: false,
      userId: '',
      storeId: '',
      storeName: '',
      storeAddress: ''
    }
  },
  created() {
    if (this.$route.query['isReport']) {
      this.activeName = 'explore'
      this.isShowReport = true
    }
    let userId = this.$route.query['userId']
    if (userId) {
      this.userId = userId
    }

    let storeId = this.$route.query['storeId']
    storeId = atob(storeId) // 解码
    if (storeId) {
      this.storeId = storeId
    }

    let storeName = this.$route.query['storeName']
    if (storeName) {
      this.storeName = storeName
    }

    let storeAddress = this.$route.query['storeAddress']
    if (storeAddress) {
      this.storeAddress = storeAddress
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style lang="less" scoped>
.explore-title {
  font-size: 14px;
  font-weight: 600;
  color: #262B2F;
  margin: 10px 0px 20px 0px !important;
}
/deep/ .el-tabs__nav-wrap:after{
  background-color: #E1E1E1 !important;
}
/deep/ .el-tabs__active-bar{
  background-color: #262B2F;
}
/deep/ .el-tabs__item.is-active{
  color: #262B2F !important;
  font-family: Satoshi-Bold !important;
  font-size: 14px !important;
}
/deep/ .el-tabs__item:hover{
  color: #262B2F !important;
  font-family: Satoshi-Bold !important;
}
/deep/ .el-tabs__active-bar{
  background-color: #262B2F !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/explore-parent.vue